var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":"#","tabindex":_vm.tabIndex},on:{"click":function($event){$event.preventDefault();return _vm.loginLogout.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.linkText))])
}
var staticRenderFns = []

export { render, staticRenderFns }